<template>
  <div class="irp-populations-cell">
    <template v-if="firstPopulation">
      <BittsTag
        :text="firstPopulation.name"
        color="info"
        size="x-small"
        class="irp-populations-cell__tag"
      />
      <BittsPopover
        v-if="overflowPopulations.length"
        trigger="hover"
        placement="bottomLeft"
        :mount-to-body="true"
      >
        <span class="irp-populations-cell__overflow">
          +{{ overflowPopulations.length }}
        </span>
        <template #content>
          <div class="irp-populations-cell__list">
            <BittsTag
              v-for="population in overflowPopulations"
              :key="population.id"
              :text="population.name"
              color="info"
              size="x-small"
            />
          </div>
        </template>
      </BittsPopover>
    </template>
    <span v-else class="irp-populations-cell__empty">&mdash;</span>
  </div>
</template>

<script setup lang="ts">
import { BittsPopover, BittsTag } from '@crossbeam/bitts';

import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import { usePopulationsStore } from '@/stores';
import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const populationsStore = usePopulationsStore();

const populations = computed(() =>
  (params.data?.partner_population_ids ?? [])
    .map(populationsStore.getPartnerPopulationById)
    .filter((population) => !!population),
);

const firstPopulation = computed(() => populations.value[0]);
const overflowPopulations = computed(() => populations.value.slice(1));
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-populations-cell {
  @apply flex items-center gap-4 h-full w-full;
}

.irp-populations-cell__tag {
  @apply min-w-0;
}

.irp-populations-cell__tag .ant-tag {
  @apply mr-0 truncate block;
}

.irp-populations-cell__overflow {
  @apply shrink-0 cursor-default text-sm text-neutral-text-weak;
}

.irp-populations-cell__list {
  @apply flex flex-col items-start gap-4 p-8;
}
</style>
